import React, { useState, useEffect, useCallback } from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";
import axios from "axios";
import swal from "sweetalert";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/swiper.min.css";
import SwiperCore, { Autoplay } from "swiper/core";
import FloatingDiamond from '../components/FloatingDiamond'; //
import Header from "../components/Header";
import Footer from "../components/Footer";
import { useGame } from "../../context/GameContext";

SwiperCore.use([Autoplay]);

const LEFT_MENU_ITEMS = [
    { id: "0", name: "Hot", imgNormal: "https://i.ibb.co/nqfMwzP8/t-i-xu-ng-10.png", imgActive: "https://i.ibb.co/1JjvtLz3/t-i-xu-ng-19.png" },
    { id: "9", name: "Game 3D", imgNormal: "https://i.ibb.co/s91t3V36/t-i-xu-ng-11.png", imgActive: "https://i.ibb.co/YFyTwtZk/t-i-xu-ng-21.png" },
    { id: "2", name: "Casino", imgNormal: "https://i.ibb.co/Kj8dpf2H/t-i-xu-ng-12.png", imgActive: "https://i.ibb.co/5hp8srkG/nav-live-active-8df40c34.png" },
    { id: "4", name: "Nổ Hũ", imgNormal: "https://i.ibb.co/SXy25T2M/t-i-xu-ng-15.png", imgActive: "https://i.ibb.co/LDQBJ174/t-i-xu-ng-22.png" },
    { id: "12", name: "Đá Gà", imgNormal: "https://i.ibb.co/Ng2kt8t3/t-i-xu-ng-14.png", imgActive: "https://i.ibb.co/Zp3VpPyg/t-i-xu-ng-23.png" },
    { id: "6", name: "Bắn Cá", imgNormal: "https://i.ibb.co/7tR6Yf2Z/t-i-xu-ng-16.png", imgActive: "https://i.ibb.co/Q751Txhx/t-i-xu-ng-24.png" },
    { id: "5", name: "Game Bài", imgNormal: "https://i.ibb.co/ynh5pHwD/t-i-xu-ng-17.png", imgActive: "https://i.ibb.co/TG9f3q6/t-i-xu-ng-25.png" },
    { id: "1", name: "Thể Thao", imgNormal: "https://i.ibb.co/zHXNxPKV/t-i-xu-ng-13.png", imgActive: "https://i.ibb.co/BKctKtr3/nav-sport-active-b3ae1864.png" },
    { id: "8", name: "Xổ Số", imgNormal: "https://i.ibb.co/jvDczH1z/t-i-xu-ng-18.png", imgActive: "https://i.ibb.co/zTw02S5q/t-i-xu-ng-26.png" }
];

const PROVIDERS_RNG = [
    { id: "98", name: "PG" }, { id: "140", name: "JILI" }, { id: "16", name: "CQ9" },
    { id: "55", name: "JDB" }, { id: "39", name: "PP" }, { id: "43", name: "MG" }
]; 
const PROVIDERS_FISH = [
    { id: "140", name: "JILI" }, { id: "16", name: "CQ9" }, { id: "55", name: "JDB" },
]; 
const PROVIDERS_PVP = [
    { id: "102", name: "V8 POKER" }, { id: "121", name: "KINGMAKER" }
];
const PROVIDERS_LIVE = [
    { id: "112", name: "SEXY" }, { id: "27", name: "DG" }, { id: "118", name: "WM" }, { id: "4", name: "SA" }
];

const getProviderLogo = (name) => {
    try {
        const safeName = name ? name.replace(" PLUS", "") : "";
        const logos = {
            "JILI": require("../../images/moi/jili.png"),
            "PG": require("../../images/moi/pg.png"),
            "PP": require("../../images/moi/pp.png"),
            "CQ9": require("../../images/moi/cq9.png"),
            "JDB": require("../../images/moi/jdb.png"),
            "MG": require("../../images/moi/mg_plus.png"),
            "V8 POKER": "https://images.5949390294.com//TCG_PROD_IMAGES/RNG_LIST_VENDOR/LCC-COLOR.png",
            "KINGMAKER": "https://images.5949390294.com//TCG_PROD_IMAGES/RNG_LIST_VENDOR/KM-COLOR.png"
        };
        return logos[safeName] || ""; 
    } catch (error) { return ""; }
};

const isMobileDevice = () => /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);

function Home() {
    const url = `${process.env.REACT_APP_API_URL}/auth/getUser`;
    const { openGlobalGame } = useGame();
    const navigate = useNavigate();
    const location = useLocation();
    
    const swiperParams = { autoplay: { delay: 3000, disableOnInteraction: false } };
    const searchParams = new URLSearchParams(window.location.search);
    
    axios.interceptors.request.use((config) => {
        const token = localStorage.getItem("user");
        if (token) config.headers["Authorization"] = `Bearer ${token}`;
        return config;
    }, (error) => Promise.reject(error));

    const [profile, setProfile] = useState(JSON.parse(localStorage.getItem("profile") || "null"));
    const [notify, setNotify] = useState(JSON.parse(localStorage.getItem("notify") || "[]"));
    const [bet, setBet] = useState(JSON.parse(localStorage.getItem("xsmb") || "null"));
    const [isLoading, setLoading] = useState(false);
    
    const [activeOption, setActiveOption] = useState("0");
    const [activeRightTab, setActiveRightTab] = useState("hot"); 
    const [searchTerm, setSearchTerm] = useState("");

    const [activeProviders, setActiveProviders] = useState({
        "4": "98",  // Default Slot: PG
        "5": "102", // Default Bài: V8
        "6": "140"  // Default Cá: JILI
    });

    const [favorites, setFavorites] = useState(() => JSON.parse(localStorage.getItem("cgwin_favorites") || "[]"));
    const [history, setHistory] = useState(() => JSON.parse(localStorage.getItem("cgwin_history") || "[]"));
    const [subGameList, setSubGameList] = useState([]);
    
    const [playGame, setPlayGame] = useState(null);
    const [product, setProduct] = useState("");

    const marqueeNotice = notify?.find(item => item.title === "marquee" && item.isShow === true);

    useEffect(() => { localStorage.setItem("cgwin_favorites", JSON.stringify(favorites)); }, [favorites]);
    useEffect(() => { localStorage.setItem("cgwin_history", JSON.stringify(history)); }, [history]);

    // Tự động Tải game cho Tab con (Slot, Cá, Bài)
    useEffect(() => {
        let gameType = "";
        let provId = "";
        
        if (activeOption === "4") { gameType = "RNG"; provId = activeProviders["4"]; }
        else if (activeOption === "5") { gameType = "PVP"; provId = activeProviders["5"]; }
        else if (activeOption === "6") { gameType = "FISH"; provId = activeProviders["6"]; }

        if (gameType && provId) {
            const hasGames = subGameList.some(g => String(g.providerId) === String(provId) && g.gameType === gameType);
            if (!hasGames) {
                setLoading(true);
                axios.post(`${process.env.REACT_APP_API_URL}/casino/getgamelist`, {
                    product_type: provId, game_type: gameType
                }).then(res => {
                    setLoading(false);
                    if (res.data && res.data.data && res.data.data.length > 0) {
                        const rawGames = Array.isArray(res.data.data[0]) ? res.data.data[0] : res.data.data;
                        const formattedGames = rawGames.map(g => {
                            let imageUrl = g.showIcon || "";
                            if (imageUrl.includes("https://images.b728484.com:42666")) {
                                imageUrl = imageUrl.replace("https://images.b728484.com:42666", "https://images.21947392.com");
                            }
                            return {
                                providerId: provId, gameType: gameType, gameName: g.gameName,
                                tcgGameCode: g.tcgGameCode, img: imageUrl, status: g.displayStatus === 0 ? 1 : 0, apiCodeOverride: g.productCode
                            };
                        });
                        setSubGameList(prev => {
                            const filtered = prev.filter(p => !(String(p.providerId) === String(provId) && p.gameType === gameType));
                            return [...filtered, ...formattedGames];
                        });
                    }
                }).catch(err => {
                    setLoading(false);
                });
            }
        }
    }, [activeOption, activeProviders]);

    const getProfile = useCallback(() => {
        axios.get(url).then((res) => {
            if (res.data && res.data.data) {
                setProfile(res.data.data);
                localStorage.setItem("profile", JSON.stringify(res.data.data));
            }
        }).catch(() => {
            localStorage.removeItem("user");
            localStorage.removeItem("profile");
        });
    }, [url]);

    useEffect(() => {
        getProfile();
        axios.get(`${process.env.REACT_APP_API_URL}/auth/getnotify`).then((res) => {
            if (res.data && res.data.data) {
                setNotify(res.data.data);
                localStorage.setItem("notify", JSON.stringify(res.data.data));
            }
        });
        const timer = setTimeout(() => {
            axios.get(`https://www.vnlottery.net/api/front/open/lottery/history/list/game?limitNum=4&gameCode=miba`)
                .then((res) => {
                    if (res.data?.t) { setBet(res.data.t); localStorage.setItem("xsmb", JSON.stringify(res.data.t)); }
                }).catch(err => console.error("Lỗi lấy xổ số:", err));
        }, 5000);
        return () => clearTimeout(timer);
    }, [location, getProfile]);

    useEffect(() => { if (profile) axios.get(`${process.env.REACT_APP_API_URL}/casino/create`).catch(e=>e); }, [profile]);

    useEffect(() => {
        const handleBalanceUpdate = () => getProfile();
        window.addEventListener("balanceUpdated", handleBalanceUpdate);
        return () => window.removeEventListener("balanceUpdated", handleBalanceUpdate);
    }, [getProfile]);

    useEffect(() => {
        const hasHotGames = subGameList.some(g => String(g.providerId) === "16");
        if (!hasHotGames && activeOption === "0") {
            setLoading(true);
            axios.post(`${process.env.REACT_APP_API_URL}/casino/getgamelist`, { product_type: "16", game_type: "RNG" }).then(res => {
                setLoading(false);
                if (res.data && res.data.data && res.data.data.length > 0) {
                    const rawGames = Array.isArray(res.data.data[0]) ? res.data.data[0] : res.data.data;
                    const formattedGames = rawGames.map(g => {
                        let imageUrl = g.showIcon || "";
                        if (imageUrl.includes("https://images.b728484.com:42666")) imageUrl = imageUrl.replace("https://images.b728484.com:42666", "https://images.21947392.com");
                        return {
                            providerId: "16", gameType: "RNG", gameName: g.gameName,
                            tcgGameCode: g.tcgGameCode, img: imageUrl, status: g.displayStatus === 0 ? 1 : 0, apiCodeOverride: g.productCode
                        };
                    });
                    setSubGameList(prev => {
                        const filtered = prev.filter(p => String(p.providerId) !== "16");
                        return [...filtered, ...formattedGames];
                    });
                }
            }).catch(err => setLoading(false));
        }
    }, [activeOption]);

    const handleOptionClick = (option) => { 
        setActiveOption(option);
        setSearchTerm("");
        if (option === "0") setActiveRightTab("hot"); 
        else if (["4","5","6"].includes(option)) setActiveRightTab("all");
    };

    const handleRefresh = () => { setLoading(true); getProfile(); setTimeout(() => setLoading(false), 1000); };

    const toggleFavorite = (e, game, providerId, gameType) => {
        e.stopPropagation();
        const isFav = favorites.find(f => f.tcgGameCode === game.tcgGameCode && String(f.providerId) === String(providerId));
        if (isFav) setFavorites(favorites.filter(f => !(f.tcgGameCode === game.tcgGameCode && String(f.providerId) === String(providerId))));
        else setFavorites([{ ...game, providerId, gameType }, ...favorites]);
    };

    const handlePlaySubGame = (game, providerId, gameType) => {
        let newHistory = history.filter(h => !(h.tcgGameCode === game.tcgGameCode && String(h.providerId) === String(providerId)));
        newHistory = [{ ...game, providerId, gameType }, ...newHistory].slice(0, 30);
        setHistory(newHistory);
        launchGame({ product_type: providerId, game_code: game.tcgGameCode, apiCodeOverride: game.apiCodeOverride });
    };

    const launchGame = async (params) => {
        if (profile === null) { navigate("/login"); return; }
        if (isLoading == true) return;
        
        const form = { ...params, platform: isMobileDevice() == true ? "html5" : "html5-desktop" };
        setLoading(true);
        
        let a;
        switch (params.product_type) {
            case "4": a = "AG"; break; case "79": a = "BBIN"; break; case "104": a = "CMD"; break;
            case "16": a = "CQ9"; break; case "27": a = "DG"; break; case "86": a = "Evolution"; break;
            case "142": a = "FB"; break; case "140": a = "JILI"; break; case "121": a = "KingMaker"; break;
            case "102": a = "V8 Poker"; break; case "43": a = "MG"; break; case "39": a = "PP"; break;
            case "174": a = "SABA"; break; case "118": a = "WM"; break; case "112": a = "SEXY"; break;
            case "54": a = "SBO"; break; case "151": a = "UG"; break; case "99": a = "TF"; break;
            case "55": a = "JDB"; break; case "202": a = "WS168"; break; case "61": a = "IMES"; break;
            default: a = "GAME"; break;
        }
        setProduct(params.product_type);

        try {
            const res = await axios.post(`${process.env.REACT_APP_API_URL}/casino/launchgame`, form);
            if (res.data.data.status == 0 || res.data.data.game_url) {
                const gameUrl = res.data.data.game_url;
                const resUser = await axios.get(`${process.env.REACT_APP_API_URL}/auth/getUser`);
                const currentMoney = Math.floor(Number(resUser.data.data.money) || 0);

                if (currentMoney >= 1000) {
                    try {
                        await axios.post(`${process.env.REACT_APP_API_URL}/casino/transfer`, {
                            product_type: String(params.product_type),
                            api_code: params.apiCodeOverride || String(params.product_type),
                            type: 1, money: currentMoney
                        });
                        setProfile({...resUser.data.data, money: Number(resUser.data.data.money) - currentMoney}); 
                    } catch (transferErr) { console.error("Lỗi chuyển quỹ: ", transferErr); }
                }
                
                localStorage.setItem("STUCK_GAME_ID", params.product_type);
                localStorage.setItem("playing_sanh", params.product_type);

                if (typeof openGlobalGame === 'function') openGlobalGame(gameUrl, a, params.product_type, params.apiCodeOverride || String(params.product_type), "VND");
                else setPlayGame(gameUrl); 
                
                setLoading(false);
            } else {
                setLoading(false); swal("Bảo trì", "Sảnh game đang bảo trì, vui lòng quay lại sau.", "error");
            }
        } catch (err) {
            setLoading(false);
            if (err.response?.data?.data?.tokenVerificationData?.access == false) {
                swal("Đã xảy ra lỗi", "Vui lòng đăng xuất và đăng nhập lại", "error").then(() => { localStorage.removeItem("user"); navigate("/login"); });
                return;
            }
            swal("Thất bại", err.response?.data?.message != "internal server error" ? err.response?.data?.message : "Đã có lỗi xảy ra", "error");
        }
    };

    const closeGame = async () => {
        setPlayGame(null); setLoading(true);  
        try {
            const currentProduct = product || localStorage.getItem("playing_sanh");
            if (currentProduct) {
                const balanceRes = await axios.post(`${process.env.REACT_APP_API_URL}/casino/getbalance`, { product_type: currentProduct });
                const currentBalance = balanceRes.data.data.balance;
                if (currentBalance > 0) {
                    await axios.post(`${process.env.REACT_APP_API_URL}/casino/transfer`, { product_type: currentProduct, type: 2, money: Math.floor(currentBalance) });
                }
                localStorage.removeItem("playing_sanh"); localStorage.removeItem("STUCK_GAME_ID");
            }
            getProfile(); setLoading(false);
        } catch (error) {
            setLoading(false); getProfile(); 
        }
    };

    const renderGameGrid = (gamesArray) => {
        if (!gamesArray || gamesArray.length === 0) {
            return <div style={{gridColumn: '1/-1', textAlign: 'center', padding: '30px 0', color: '#888', fontSize: '13px'}}>Chưa có dữ liệu.</div>;
        }

        return gamesArray.map((game, idx) => {
            const pId = game.providerId;
            const isFav = favorites.some(f => f.tcgGameCode === game.tcgGameCode && String(f.providerId) === String(pId));
            const isMaintenance = Number(game.status) === 0;

            return (
                <div key={`${pId}-${game.tcgGameCode}-${idx}`} className="hot-card" onClick={() => {
                    if (isMaintenance) swal("Bảo trì", "Game đang được bảo trì, vui lòng quay lại sau!", "warning");
                    else handlePlaySubGame(game, pId, game.gameType || "RNG");
                }}>
                    <div style={{ width: "100%", aspectRatio: "1/1", position: "relative", borderRadius: "8px", overflow: "hidden", background: "#f9f9f9", boxShadow: "0 2px 4px rgba(0,0,0,0.1)" }}>
                        {/* UPDATE CHỖ NÀY: THÊM CLASS ACTIVE VÀ XÓA INLINE COLOR CỦA THẺ I */}
                        <div className={`fav-star-wrap ${isFav ? 'active' : ''}`} onClick={(e) => toggleFavorite(e, game, pId, game.gameType || "RNG")}>
                            <i className="fa-solid fa-star" style={{ fontSize: "12px" }}></i>
                        </div>
                        <img src={game.img} alt={game.gameName} style={{ position: "absolute", top: 0, left: 0, width: "100%", height: "100%", objectFit: "cover", opacity: isMaintenance ? 0.4 : 1 }} />
                        
                        {isMaintenance && (
                            <div style={{ position: "absolute", top: 0, left: 0, width: "100%", height: "100%", background: "rgba(0,0,0,0.6)", zIndex: 6, display: "flex", alignItems: "center", justifyContent: "center" }}>
                                <div style={{ background: "rgba(0,0,0,0.7)", borderRadius: "50%", padding: "8px", display: "flex", alignItems: "center", justifyContent: "center" }}>
                                    <img src={require("../../images/moi/img_whz_style_1.avif")} alt="Bảo trì" style={{ width: "24px", height: "24px", objectFit: "contain" }} />
                                </div>
                            </div>
                        )}
                    </div>
                    <div className="hot-title">{game.gameName}</div>
                </div>
            );
        });
    };

    const renderInlineGames = (providerList, gameType, categoryId) => {
        const activeProvId = activeProviders[categoryId] || providerList[0].id;
        
        let displayedGames = [];
        if (activeRightTab === "all") displayedGames = subGameList.filter(g => String(g.providerId) === String(activeProvId) && g.gameType === gameType);
        else if (activeRightTab === "hot") displayedGames = subGameList.filter(g => g.gameType === gameType).slice(0, 30);
        else if (activeRightTab === "recent") displayedGames = history.filter(g => g.gameType === gameType);
        else if (activeRightTab === "fav") displayedGames = favorites.filter(g => g.gameType === gameType);

        if (searchTerm) displayedGames = displayedGames.filter(g => g.gameName.toLowerCase().includes(searchTerm.toLowerCase()));

        return (
            <>
                <div className="right-tabs" style={{ marginBottom: "10px" }}>
                    <div className={`right-tab-item ${activeRightTab === 'all' ? 'active' : ''}`} onClick={() => setActiveRightTab('all')}>Tất cả</div>
                    <div className={`right-tab-item ${activeRightTab === 'hot' ? 'active' : ''}`} onClick={() => setActiveRightTab('hot')}>Hot nhất</div>
                    <div className={`right-tab-item ${activeRightTab === 'recent' ? 'active' : ''}`} onClick={() => setActiveRightTab('recent')}>Gần đây</div>
                    <div className={`right-tab-item ${activeRightTab === 'fav' ? 'active' : ''}`} onClick={() => setActiveRightTab('fav')}>Bộ sưu tập</div>
                </div>

                {activeRightTab === "all" && (
                    <>
                        <div className="provider-horizontal-list hide-scrollbar">
                            {providerList.map(prov => {
                                const isProvActive = String(activeProvId) === String(prov.id);
                                const logo = getProviderLogo(prov.name);
                                return (
                                    <div 
                                        key={prov.id} 
                                        className={`prov-pill ${isProvActive ? 'active' : ''}`}
                                        onClick={() => setActiveProviders({...activeProviders, [categoryId]: prov.id})}
                                    >
                                        {logo ? <img src={logo} alt={prov.name} style={{filter: isProvActive ? 'none' : 'grayscale(1)'}} /> : prov.name}
                                    </div>
                                )
                            })}
                        </div>
                        <div className="filter-search-row">
                            <div className="filter-btn">Bộ lọc <i className="fa-solid fa-sliders"></i></div>
                            <div className="search-box">
                                <input 
                                    type="text" 
                                    placeholder="Tìm kiếm trò chơi" 
                                    value={searchTerm}
                                    onChange={(e) => setSearchTerm(e.target.value)}
                                />
                                <i className="fa-solid fa-magnifying-glass"></i>
                            </div>
                        </div>
                    </>
                )}

                <div className="grid-3-cols">
                    {renderGameGrid(displayedGames)}
                </div>
            </>
        )
    };

    return (
        <div style={{ display: "flex", flexDirection: "column", height: "100vh", background: "#fdfdfd", overflow: "hidden" }}>
            <style dangerouslySetInnerHTML={{__html: `
                * { 
                    font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Helvetica, Arial, sans-serif; 
                    -webkit-font-smoothing: antialiased; 
                    -moz-osx-font-smoothing: grayscale; 
                    text-rendering: optimizeLegibility;
                }
                .hide-scrollbar::-webkit-scrollbar { display: none; }
                .hide-scrollbar { -ms-overflow-style: none; scrollbar-width: none; }
                @keyframes fadeInSlideUp {
                    from { opacity: 0; transform: translateY(15px); }
                    to { opacity: 1; transform: translateY(0); }
                }

                .app-main-container {
                    position: fixed; top: 50px; bottom: 60px; left: 0; right: 0; margin: 0 auto; max-width: 540px;
                    display: flex; flex-direction: column; background: #fff; z-index: 10;
                    box-shadow: 0 0 10px rgba(0,0,0,0.05);
                    overflow-y: auto; overflow-x: hidden;
                }
                
                .top-fixed-section { flex-shrink: 0; background: #fff; z-index: 50; width: 100%; position: relative; }
                
                .bottom-split-section { 
                    display: grid; 
                    grid-template-columns: 130px minmax(0, 1fr); 
                    background: #fff; 
                    width: 100%; 
                    position: relative; 
                    z-index: 10; 
                }

                .box-slide { margin: 0; padding: 0; overflow: hidden; width: 100%; }
                .box-slide .swiper-container { padding: 0 !important; margin: 0 !important; width: 100vw !important; max-width: 100%; }
                .box-slide .swiper-slide img { width: 100% !important; height: clamp(160px, 40vw, 100px) !important; object-fit: fill !important; border-radius: 0 !important; display: block; }

                /* THÔNG BÁO VÀ BUTTON DOMAIN */
                .marquee-container { display: flex; align-items: center; justify-content: space-between; padding: 8px 12px; background: #fff; border-bottom: 1px solid #eee; }
                .domain-btn { background: #ffca28; color: #333; font-weight: bold; padding: 4px 12px; border-radius: 6px; border: 1px solid #ffb300; font-size: 12px; white-space: nowrap; }

                /* TOP ACTION BOARD CẬP NHẬT THEO ẢNH 1 */
                .action-board-wrap { padding: 12px 10px; background: #fff; border-bottom: 1px solid #eee; }
                .action-board { display: flex; justify-content: space-between; align-items: flex-end; gap: 35px; }

                .auth-column { display: flex; flex-direction: column; gap: 8px; flex: 0 0 130px; }
                .btn-login-new { background: linear-gradient(180deg, #ffde00, #ffb300); color: #333; padding: 8px 0; border-radius: 8px; font-weight: 800; font-size: 13px; text-align: center; cursor: pointer; border: 1px solid #d49a00; }
                .btn-register-new { background: linear-gradient(180deg, #a5d6a7, #66bb6a); color: #1b5e20; padding: 8px 0; border-radius: 8px; font-weight: 800; font-size: 13px; text-align: center; cursor: pointer; border: 1px solid #4caf50; }

                /* BOX THÔNG TIN - MÀU VÀNG & XANH NGỌC Y HỆT ẢNH 1 */
                .user-info-box { flex: 0 0 125px; display: flex; flex-direction: column; gap: 5px; }
                .user-id-row { 
                    background: linear-gradient(90deg, #ffeb3b, #ffc107); 
                    padding: 4px 8px; border-radius: 20px; 
                    display: flex; align-items: center; justify-content: space-between; 
                    box-shadow: 0 2px 4px rgba(0,0,0,0.1);
                }
                .vip-badge { 
                    background: #424242; color: #ffca28; font-size: 9px; font-weight: 900; 
                    padding: 3px 6px; border-radius: 6px; 
                }
                .user-id-text { color: #d32f2f; font-weight: 900; font-size: 14px; flex: 1; text-align: center; white-space: nowrap; overflow: hidden; text-overflow: ellipsis; padding: 0 4px; }
                
               .user-balance-row {
                    background: #175b19;
                    padding: 10px 2px;
                    border-radius: 8px;
                    display: flex;
                    align-items: center;
                    justify-content: space-between;
                    border: 2px solid #a5d6a7;
                    flex-direction: row;
                }
                .vn-star-icon {
                    width: 18px; height: 18px; background: #d32f2f; border-radius: 50%;
                    display: flex; align-items: center; justify-content: center;
                    color: #ffeb3b; font-size: 10px; flex-shrink: 0;
                }
                .balance-text { color: #fbc02d; font-weight: 900; font-size: 12px; flex: 1; text-align: center; }
                .balance-actions { display: flex; gap: 6px; color: #1b5e20; font-size: 13px; }
                .refresh-icon { cursor: pointer; transition: 0.3s; }
                .refresh-icon:active { transform: rotate(180deg); }

                /* CÁC NÚT BẦU DỤC TRÒN NHƯ ẢNH 1 */
                .action-links { flex: 1; display: flex; justify-content: space-between; margin-bottom: -8px;}
                .act-link { display: flex; flex-direction: column; align-items: center; justify-content: center; gap: 4px; cursor: pointer; }
                .act-icon-bg { 
                    width: 44px; height: 35px; 
                  
                    border-radius: 20px 20px 15px 15px; 
                    display: flex; align-items: flex-end; justify-content: center; 
                    padding-bottom: 3px; position: relative;
                }
                .act-icon-bg img { width: 48px; height: 45px; object-fit: contain; position: absolute; bottom: 3px; }
                .act-link span { font-size: 10px; color: #00695c; font-weight: bold; text-transform: uppercase; }

                /* CSS MENU TRÁI */
                .content-game-left { 
                    background: #fff; display: flex; flex-direction: column; padding: 15px 5px 20px 10px; 
                    position: relative; z-index: 999; box-sizing: border-box;
                }
                .menu-item { 
                    background: linear-gradient(180deg, #c2efd8, #31b78a);
                    border-radius: 8px; padding: 0 10px; margin-bottom: 12px; 
                    display: flex; flex-direction: row; align-items: center; justify-content: flex-start; gap: 8px;
                    cursor: pointer; border: 1px solid #82d4a6; height: 45px; flex-shrink: 0; 
                    box-shadow: 0 3px 5px rgba(0,0,0,0.15), inset 0 1px 2px rgba(255,255,255,0.6); 
                    transition: all 0.2s ease; 
                }
                .menu-item:active { transform: translateY(2px); box-shadow: 0 1px 2px rgba(0,0,0,0.15); }
                .menu-item.active { 
                    background: linear-gradient(180deg, #dcf5e7, #b2dfcc); border-color: #a4e5c4;
                }
                .menu-item img { width: 45px; height: 25px; object-fit: contain; }
                .menu-item h3 { font-size: 15px; color: #1a512e; font-weight: 700; margin: 0; white-space: nowrap;}
                .menu-item.active h3 { color: #00e676; }
                
                /* CONTENT BÊN PHẢI */
                .content-game-right { 
                    padding: 10px; background: transparent; padding-bottom: 30px; 
                    animation: fadeInSlideUp 0.3s ease-out; min-width: 0; 
                }
                
                /* TABS DÙNG CHUNG */
                .right-tabs { display: flex; justify-content: space-around; border-bottom: 1px solid #e0e0e0; margin-bottom: 15px; padding-bottom: 0px; }
                .right-tab-item { font-size: 13px; font-weight: bold; color: #1b5e20; padding-bottom: 8px; margin-bottom: -1px; border-bottom: 3px solid transparent; cursor: pointer; transition: 0.2s; white-space: nowrap;}
                .right-tab-item.active { color: #00bfa5; border-bottom: 3px solid #00bfa5; }

                /* COMPONENT BROWSE INLINE (GIỐNG ẢNH 2) */
                .provider-horizontal-list { display: flex; overflow-x: auto; gap: 8px; margin-bottom: 10px; padding-bottom: 5px; align-items: center; }
                .prov-pill {
                    background: #e8f5e9; padding: 4px 12px; border-radius: 6px; 
                    display: flex; align-items: center; justify-content: center;
                    min-width: 100px; height: 50px; cursor: pointer; transition: 0.2s;
                    border: 1px solid transparent; flex-shrink: 0; font-size: 13px; color: #2e7d32; font-weight: bold;
                }
                .prov-pill.active { background: #2e7d32; color: #fff; border-color: #1b5e20; }
                .prov-pill img { max-height: 50px; object-fit: contain; transition: 0.2s; }
                
                .filter-search-row { display: flex; gap: 8px; margin-bottom: 15px; }
                .filter-btn { background: #c8e6c9; color: #2e7d32; padding: 8px 12px; border-radius: 6px; font-size: 12px; font-weight: bold; display: flex; align-items: center; gap: 5px; cursor: pointer; }
                .search-box { flex: 1; background: #c8e6c9; border-radius: 6px; display: flex; align-items: center; padding: 0 10px; color: #2e7d32; }
                .search-box input { border: none; background: transparent; width: 100%; outline: none; font-size: 13px; color: #1b5e20; padding: 8px 0;}
                .search-box input::placeholder { color: #81c784; }

                /* BANNER RỒNG */
                .dragon-banner-container { position: relative; width: 100%; padding-top: 56%; margin-bottom: 15px; display: flex; justify-content: center; }
                .dragon-frame { position: absolute; top: 0; left: 0; width: 100%; height: 100%; z-index: 2; pointer-events: none; object-fit: contain; }
                .inner-video-container { position: absolute; top: 12%; left: 16%; width: 68%; height: 58%; background: #000; z-index: 1; border-radius: 12px; display: flex; align-items: center; justify-content: center; overflow: hidden; }
                .inner-video-container img { width: 100%; height: 100%; object-fit: cover; }
                .bet-btn-overlay {
                    position: absolute;
                    bottom: 6%;
                    left: 73%;
                    transform: translateX(-50%);
                    background: linear-gradient(180deg, #ffea00, #fbc02d);
                    border: 2px solid #fff;
                    color: #d32f2f;
                    font-weight: 700;
                    font-size: 12px;
                    padding: 2px 7px;
                    border-radius: 7px;
                    z-index: 3;
                    box-shadow: 0 4px 6px rgba(0, 0, 0, 0.3);
                    cursor: pointer;
                    white-space: nowrap;
                    transition: 0.2s;
                }
                .bet-btn-overlay:active { transform: translateX(-50%) scale(0.95); }

                /* LƯỚI GAME CHUNG - UPDATE LOGIC FAV STAR TẠI ĐÂY */
                .grid-3-cols { display: grid; grid-template-columns: repeat(3, minmax(0, 1fr)); gap: 8px; }
                .hot-card { display: flex; flex-direction: column; align-items: center; padding: 0; cursor: pointer; transition: 0.2s; min-width: 0; }
                .hot-card:active { transform: scale(0.96); }
                .hot-title { font-size: clamp(11px, 2.8vw, 13px); font-weight: 600; color: #444; text-align: center; margin-top: 6px; white-space: nowrap; overflow: hidden; text-overflow: ellipsis; width: 100%; display: block; }
                
               .fav-star-wrap {
    position: absolute;
    top: 6px;
    right: 6px;
    z-index: 5;
    background: rgb(0 0 0 / 77%);
    
    /* Bỏ dòng border-radius: 50%; */
    
    /* Thêm thuộc tính clip-path để tạo hình ngôi sao 5 cánh */
    clip-path: polygon(50% 0%, 61% 35%, 98% 35%, 68% 57%, 79% 91%, 50% 70%, 21% 91%, 32% 57%, 2% 35%, 39% 35%);
    
    width: 22px;
    height: 22px;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    transition: all 0.2s ease;
}
                .fav-star-wrap i { color: rgba(255,255,255,0.6); transition: color 0.2s ease; }
                .fav-star-wrap.active { background: rgb(255 108 0); }
                .fav-star-wrap.active i { color: #ffdd00; text-shadow: 0 0 5px rgba(255,221,0,0.5); }
                .fav-star-wrap:active { transform: scale(1.2); }

                /* LƯỚI CASINO 2 CỘT */
                .provider-grid-2-cols { display: grid; grid-template-columns: repeat(2, minmax(0, 1fr)); gap: 10px; width: 100%; }
                .provider-card-v2 { position: relative; background: #fff; border-radius: 8px; overflow: hidden; box-shadow: 0 2px 5px rgba(0,0,0,0.1); aspect-ratio: 3/2; cursor: pointer; transition: transform 0.2s; border: 1px solid #e0e0e0; }
                .provider-card-v2:active { transform: scale(0.96); }
                .provider-card-v2 img { width: 100%; height: 100%; object-fit: cover; }

                .casino-list { display: flex; flex-direction: column; gap: 15px; width: 100%; }
                .casino-card { position: relative; background: linear-gradient(135deg, #fffdf5, #fff); border-radius: 12px; border: 1px solid #ffffff; box-shadow: 0 4px 8px rgba(0,0,0,0.05); height: clamp(90px, 25vw, 130px); display: flex; align-items: center; justify-content: space-between; overflow: hidden; cursor: pointer; transition: transform 0.2s; }
                .casino-card:active { transform: scale(0.98); }
                .casino-right { position: absolute; top: 0; left: 0; width: 100%; height: 100%; z-index: 1; }
                .casino-right img { width: 100%; height: 90%; object-fit: cover; object-position: right center; }

                .iframe-overlay { position: fixed; top: 0; left: 0; width: 100%; height: 100%; background: #000; z-index: 999999; display: flex; flex-direction: column; }
                .iframe-header { height: 50px; background: #222; display: flex; justify-content: space-between; align-items: center; padding: 0 15px; color: #fff; }
                .iframe-close-btn { background: #f44336; padding: 5px 15px; border-radius: 4px; font-weight: bold; cursor: pointer; }
            `}} />

            {playGame && (
                <div className="iframe-overlay">
                    <div className="iframe-header">
                        <span style={{ fontWeight: "bold" }}>Game Lobby</span>
                        <div className="iframe-close-btn" onClick={closeGame}>Đóng Game & Thu Hồi Điểm</div>
                    </div>
                    <iframe src={playGame} title="Game Play" style={{ flex: 1, width: "100%", border: "none" }} />
                </div>
            )}

            {isLoading && <div className="loading" style={{zIndex: 99999}}><div className="loader"></div></div>}
            
            <Header profile={profile} />
             <FloatingDiamond />
            <div className="app-main-container">
                <div className="top-fixed-section">
                      {swiperParams && notify && bet?.issueList && (
                        <div className="box-slide">
                            <Swiper {...swiperParams}>
                                {notify.map((item, index) => (
                                    <React.Fragment key={index}>
                                        {index > 1 && item.title !== "marquee" && item.isShow === true ? (
                                            <SwiperSlide>
                                                <img alt={item.title.replace("}", "").replace("{", "")} src={item.image} />
                                            </SwiperSlide>
                                        ) : null}
                                    </React.Fragment>
                                ))}
                            </Swiper>
                            
                            {marqueeNotice && (
                                <div className="marquee-container">
                                    <i className="fa-solid fa-bullhorn" style={{ color: '#00796b', fontSize: '16px' }}></i>
                                    <div style={{ flex: 1, overflow: "hidden", whiteSpace: "nowrap", display: "flex", alignItems: "center", margin: "0 10px" }}>
                                        <div className="chaychu" style={{ animation: "chuchay " + (marqueeNotice.content.length / 15) + "s linear infinite", display: "inline-block", color: "#666", fontSize: "13px" }} dangerouslySetInnerHTML={{ __html: marqueeNotice.content.replace(/<[^>]+>/g, " ") }} />
                                    </div>
                                    <div className="domain-btn">bcr555.com</div>
                                </div>
                            )}
                        </div>
                    )}

                    {/* ACTION BOARD ĐƯỢC CHỈNH LẠI Y HỆT ẢNH 1 */}
                    <div className="action-board-wrap">
                        <div className="action-board">
                            {!profile ? (
                                <div className="auth-column">
                                    <div className="btn-login-new" onClick={() => navigate("/login")}>Đăng Nhập</div>
                                    <div className="btn-register-new" onClick={() => navigate("/register")}>Đăng ký</div>
                                </div>
                            ) : (
                                <div className="user-info-box">
                                  <div className="user-balance-row">
  
    <span className="balance-text">{parseFloat(profile.money || 0).toLocaleString("vi-VN")} VND</span>
    <div className="balance-actions">
        <i className="fa-regular fa-eye" style={{ cursor: "pointer" }}></i>
        <i className="fa-solid fa-rotate-right refresh-icon" onClick={handleRefresh}></i>
    </div>
</div>
                                </div>
                            )}

                            <div className="action-links">
                                <div className="act-link" onClick={() => navigate("/recharge/bank")}>
                                    <div className="act-icon-bg"><img src="https://i.ibb.co/xK5LRcSK/demo-removebg-preview.png" alt="Nạp Tiền" /></div>
                                    <span>NẠP TIỀN</span>
                                </div>
                                <div className="act-link" onClick={() => navigate("/withdraw")}>
                                    <div className="act-icon-bg"><img src="https://i.ibb.co/wNPgvXsG/demo-1-removebg-preview.png" alt="Rút Tiền" /></div>
                                    <span>RÚT TIỀN</span>
                                </div>
                                <div className="act-link" onClick={() => navigate("/vip")}>
                                    <div className="act-icon-bg"><img src="https://i.ibb.co/Cpb4NzK1/demo-2-removebg-preview.png" alt="VIP" /></div>
                                    <span>VIP</span>
                                </div>
                                <div className="act-link" onClick={() => navigate("/invite")}>
                                    <div className="act-icon-bg"><img src="https://i.ibb.co/FkMWnH4c/demo-3-removebg-preview.png" alt="Mời" /></div>
                                    <span>MỜI</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="bottom-split-section">
                    <div className="content-game-left hide-scrollbar">
                        {LEFT_MENU_ITEMS.map((item) => {
                            const isActive = activeOption === item.id;
                            return (
                                <div 
                                    key={item.id} 
                                    className={`menu-item ${isActive ? "active" : ""}`} 
                                    onClick={() => handleOptionClick(item.id)}
                                >
                                    <img src={isActive ? item.imgActive : item.imgNormal} alt={item.name} />
                                    <h3>{item.name}</h3>
                                </div>
                            );
                        })}
                    </div>

                    <div className="content-game-right hide-scrollbar" key={activeOption}>
                        
                        {/* TAB HOT */}
                        {activeOption === "0" && (
                            <>
                                {activeRightTab === "hot" && (
                                    <div className="dragon-banner-container">
                                        <div className="inner-video-container">
                                            <img src={require("../../images/moi/ae.avif")} alt="Live Stream Placeholder" />
                                        </div>
                                        <img src="https://i.ibb.co/Rkzz2ZTN/live-stream-bg-39704f21-removebg-preview.png" alt="Dragon Frame" className="dragon-frame" />
                                        <div className="bet-btn-overlay" onClick={() => launchGame({ product_type: "112", game_code: "SEX001" })}>
                                            ĐẶT CƯỢC NGAY
                                        </div>
                                    </div>
                                )}

                                <div className="right-tabs">
                                    <div className={`right-tab-item ${activeRightTab === 'hot' ? 'active' : ''}`} onClick={() => setActiveRightTab('hot')}>Hot nhất</div>
                                    <div className={`right-tab-item ${activeRightTab === 'recent' ? 'active' : ''}`} onClick={() => setActiveRightTab('recent')}>Gần đây</div>
                                    <div className={`right-tab-item ${activeRightTab === 'fav' ? 'active' : ''}`} onClick={() => setActiveRightTab('fav')}>Bộ sưu tập</div>
                                </div>

                                <div className="grid-3-cols">
                                    {activeRightTab === "hot" && renderGameGrid(subGameList.filter(g => String(g.providerId) === "16").slice(0, 20))}
                                    {activeRightTab === "recent" && renderGameGrid(history)}
                                    {activeRightTab === "fav" && renderGameGrid(favorites)}
                                </div>
                            </>
                        )}

                        {activeOption === "9" && (
                            <div className="grid-3-cols">
                               
                                <div className="hot-card" onClick={() => navigate("/tx45s")}>
                                    <div style={{ width: "100%", aspectRatio: "1/1", position: "relative", borderRadius: "8px", overflow: "hidden", background: "#f9f9f9", border: "1px solid #eee" }}>
                                        <img src={require("../../static/tx45.png")} alt="tx45" style={{ position: "absolute", top: 0, left: 0, width: "100%", height: "100%", objectFit: "cover" }} />
                                    </div>
                                    <div className="hot-title">Tài Xỉu 45s</div>
                                </div>
                                <div className="hot-card" onClick={() => navigate("/tx60s")}>
                                    <div style={{ width: "100%", aspectRatio: "1/1", position: "relative", borderRadius: "8px", overflow: "hidden", background: "#f9f9f9", border: "1px solid #eee" }}>
                                        <img src={require("../../static/tx60.png")} alt="tx60" style={{ position: "absolute", top: 0, left: 0, width: "100%", height: "100%", objectFit: "cover" }} />
                                    </div>
                                    <div className="hot-title">Tài Xỉu 60s</div>
                                </div>
                                <div className="hot-card" onClick={() => navigate("/xd45s")}>
                                    <div style={{ width: "100%", aspectRatio: "1/1", position: "relative", borderRadius: "8px", overflow: "hidden", background: "#f9f9f9", border: "1px solid #eee" }}>
                                        <img src={require("../../static/xd45.png")} alt="xd45" style={{ position: "absolute", top: 0, left: 0, width: "100%", height: "100%", objectFit: "cover" }} />
                                    </div>
                                    <div className="hot-title">Xóc Đĩa 45s</div>
                                </div>
                                <div className="hot-card" onClick={() => navigate("/xd60s")}>
                                    <div style={{ width: "100%", aspectRatio: "1/1", position: "relative", borderRadius: "8px", overflow: "hidden", background: "#f9f9f9", border: "1px solid #eee" }}>
                                        <img src={require("../../static/xd60.png")} alt="xd60" style={{ position: "absolute", top: 0, left: 0, width: "100%", height: "100%", objectFit: "cover" }} />
                                    </div>
                                    <div className="hot-title">Xóc Đĩa 60s</div>
                                </div>
                            </div>
                        )}

                        {activeOption === "2" && (
                            <div className="provider-grid-2-cols">
                             <div 
    className="provider-card-v2" 
    style={{ position: 'relative', display: 'inline-block' }} 
    onClick={() => launchGame({ product_type: "112", game_code: "SEX001" })}
>
    {/* Ảnh nền */}
    <img 
        src="https://images.6223027.com/prod-images/game_icon/6789vndkf5/h5BigImage/gcs__LIVE-SEX_1744716968405.webp" 
        alt="SEXY" 
        style={{ display: 'block', width: '100%', height: 'auto' }} 
    />
    
    {/* Logo chèn thêm (Tự co giãn theo % của div cha) */}
    <img 
        src="https://images.5949390294.com//TCG_PROD_IMAGES/RNG_LIST_VENDOR/SEX-COLOR2.png" 
        alt="Logo" 
        style={{
            position: 'absolute',
            top: '5%',           // Logo cách mép trên 5% chiều cao ảnh
            right: '48%',         // Logo cách mép phải 5% chiều ngang ảnh
            width: '50%',        // Logo chiếm 25% chiều rộng ảnh (tự co giãn)
            height: 'auto',
            pointerEvents: 'none' 
        }} 
    />
</div>

                                 <div className="provider-card-v2" onClick={() => launchGame({ product_type: "86", game_code: "EG0001" })}>
                                    <img src="https://images.6223027.com/prod-images/game_icon/6789vndkf5/h5BigImage/gcs__LIVE-EG4_1744761477226.webp" alt="EVO" />
                                     <img 
        src="https://images.5949390294.com//TCG_PROD_IMAGES/RNG_LIST_VENDOR/EG4-COLOR2.png" 
        alt="Logo" 
        style={{
            position: 'absolute',
            top: '5%',           // Logo cách mép trên 5% chiều cao ảnh
            right: '48%',         // Logo cách mép phải 5% chiều ngang ảnh
            width: '50%',        // Logo chiếm 25% chiều rộng ảnh (tự co giãn)
            height: 'auto',
            pointerEvents: 'none' 
        }} 
    />
                                </div>

                                <div className="provider-card-v2" onClick={() => launchGame({ product_type: "27", game_code: "DG0013" })}>
                                    <img src="https://images.6223027.com/prod-images/game_icon/6789vndkf5/h5BigImage/gcs__LIVE-DG_1744716966245.webp" alt="DG" />
                                     <img 
        src="https://images.5949390294.com//TCG_PROD_IMAGES/RNG_LIST_VENDOR/DG-COLOR2.png" 
        alt="Logo" 
        style={{
            position: 'absolute',
            top: '5%',           // Logo cách mép trên 5% chiều cao ảnh
            right: '48%',         // Logo cách mép phải 5% chiều ngang ảnh
            width: '50%',        // Logo chiếm 25% chiều rộng ảnh (tự co giãn)
            height: 'auto',
            pointerEvents: 'none' 
        }} 
    />
                                </div>
                                <div className="provider-card-v2" onClick={() => launchGame({ product_type: "118", game_code: "WM0001" })}>
                                    <img src="https://images.6223027.com/prod-images/game_icon/6789vndkf5/h5BigImage/gcs__LIVE-WM_1744716969235.webp" alt="WM" />
                                     <img 
        src="https://images.5949390294.com//TCG_PROD_IMAGES/RNG_LIST_VENDOR/WM-COLOR2.png" 
        alt="Logo" 
        style={{
            position: 'absolute',
            top: '5%',           // Logo cách mép trên 5% chiều cao ảnh
            right: '48%',         // Logo cách mép phải 5% chiều ngang ảnh
            width: '50%',        // Logo chiếm 25% chiều rộng ảnh (tự co giãn)
            height: 'auto',
            pointerEvents: 'none' 
        }} 
    />
                                </div>
                                <div className="provider-card-v2" onClick={() => launchGame({ product_type: "4", game_code: "A00070" })}>
                                    <img src="https://images.6223027.com/prod-images/game_icon/6789vndkf5/h5BigImage/gcs__LIVE-AG_1744716965382.webp" alt="SA" />
                                     <img 
        src="https://images.5949390294.com//TCG_PROD_IMAGES/RNG_LIST_VENDOR/AG-COLOR2.png" 
        alt="Logo" 
        style={{
            position: 'absolute',
            top: '5%',           // Logo cách mép trên 5% chiều cao ảnh
            right: '48%',         // Logo cách mép phải 5% chiều ngang ảnh
            width: '50%',        // Logo chiếm 25% chiều rộng ảnh (tự co giãn)
            height: 'auto',
            pointerEvents: 'none' 
        }} 
    />
                                </div>
                            </div>
                        )}

                        {/* RENDER INLINE CHO NỔ HŨ, BÀI, BẮN CÁ NHƯ ẢNH 2 */}
                        {activeOption === "4" && renderInlineGames(PROVIDERS_RNG, "RNG", "4")}
                        {activeOption === "5" && renderInlineGames(PROVIDERS_PVP, "PVP", "5")}
                        {activeOption === "6" && renderInlineGames(PROVIDERS_FISH, "FISH", "6")}

                        {activeOption === "1" && (
                            <div className="casino-list">
                                <div className="casino-card" onClick={() => launchGame({ product_type: "174", game_code: "SB0001" })}>
                                    <div className="casino-right"><img src="https://images.6223027.com/prod-images/game_icon/6789vndkf5/h5BigImage/gcs__SPORTS-SB_1742356019412.webp" alt="SABA" /></div>
                                </div>
                                 <div className="casino-card" onClick={() => launchGame({ product_type: "142", game_code: "FB0001" })}>
                                    <div className="casino-right"><img src="https://images.6223027.com/prod-images/game_icon/6789vndkf5/h5BigImage/gcs__SPORTS-3S2_1742356017169.webp" alt="FB" /></div>
                                </div>
                               <div className="casino-card"  onClick={() => launchGame({ product_type: "54", game_code: "SBO041" })}>
                                    <div className="casino-right"><img src="https://images.6223027.com/prod-images/game_icon/6789vndkf5/h5BigImage/gcs__SPORTS-PIN_1742356018862.webp" alt="SBO" /></div>
                                </div>
                                 <div className="casino-card"  onClick={() => launchGame({ product_type: "151", game_code: "UG2001" })}>
                                    <div className="casino-right"><img src="https://images.6223027.com/prod-images/game_icon/6789vndkf5/h5BigImage/gcs__SPORTS-UG2_1742356019952.webp" alt="UG" /></div>
                                </div>
                                 <div className="casino-card"  onClick={() => launchGame({ product_type: "104", game_code: "CMD001" })}>
                                    <div className="casino-right"><img src="https://images.6223027.com/prod-images/game_icon/6789vndkf5/h5BigImage/gcs__SPORTS-CMD_1742356017638.webp" alt="CMD" /></div>
                                </div>
                            </div>
                        )}

                        {activeOption === "12" && (
                            <div className="casino-list">
                                <div className="casino-card" onClick={() => launchGame({ product_type: "202", game_code: "WS1682" })}>
                                    <div className="casino-right"><img src="https://images.6223027.com/prod-images/game_icon/6789vndkf5/h5BigImage/gcs__SPORTS-WS168_1762328246246.webp" alt="WS168" /></div>
                                </div>
                            </div>
                        )}

                        {activeOption === "7" && (
                            <div className="casino-list">
                                <div className="casino-card" onClick={() => launchGame({ product_type: "61", game_code: "IMES17" })}>
                                    <div className="casino-right"><img src={require("../../images/moi/ia.png")} alt="AI" /></div>
                                </div>
                                 <div className="casino-card" onClick={() => launchGame({ product_type: "99", game_code: "TF0001" })}>
                                    <div className="casino-right"><img src={require("../../images/moi/tf.png")} alt="TF" /></div>
                                </div>
                            </div>
                        )}
                        
                        {activeOption === "8" && (
                            <div className="casino-list">
                                <div className="casino-card"  onClick={() => navigate("/xs75s/lo2")}>
                                    <div className="casino-right"><img src={require("../../images/moi/71f3a1a6-d57d-497b-8e07-160.jpg")} alt="XS75s" /></div>
                                </div>
                                <div className="casino-card"  onClick={() => navigate("/xs120s/lo2")}>
                                    <div className="casino-right"><img src={require("../../images/moi/71f3a1a6-d57d-497b-8e07-160.jpg")} alt="XS120s" /></div>
                                </div>
                                 <div className="casino-card"  onClick={() => navigate("/xsmb/lo2")}>
                                    <div className="casino-right"><img src={require("../../images/moi/e7e3cacc-9876-4315-9b7a-a6ecff510ba6.jpg")} alt="" /></div>
                                </div>
                                <div className="casino-card"  onClick={() => navigate("/xsmn/lo2")}>
                                    <div className="casino-right"><img src={require("../../images/moi/6149133e-771c-411c-91cd-cd9eeea57d53.jpg")} alt="" /></div>
                                </div>
                                <div className="casino-card"  onClick={() => navigate("/xsmt/lo2")}>
                                    <div className="casino-right"><img src={require("../../images/moi/fdde502a-8e16-43a1-bf9b-99b7.jpg")} alt="" /></div>
                                </div>
                            </div>
                        )}
                    </div> 
                </div> 
            </div> 
            
            <Footer />
        </div>
    );
}

export default Home;